__turbopack_context__.v({
  "content": "Layout-module__ktrb7q__content",
  "footer": "Layout-module__ktrb7q__footer",
  "footer-content": "Layout-module__ktrb7q__footer-content",
  "img": "Layout-module__ktrb7q__img",
  "imgResponsive": "Layout-module__ktrb7q__imgResponsive",
  "language-selector-wrapper": "Layout-module__ktrb7q__language-selector-wrapper",
  "light": "Layout-module__ktrb7q__light",
  "root": "Layout-module__ktrb7q__root",
});
